<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Broadcast</h3>
                <p class="text-muted mb-2">
                  Siapkan beberapa variasi pesan untuk digunakan dalam broadcast.
                </p>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link :to="'/message_report/broadcast'"
                      >Broadcast</router-link
                    >
                  </li>
                  <li v-if="this.$route.query.id" class="breadcrumb-item">
                    <router-link :to="'/message_report/broadcast/info/?id=' + this.$route.query.id">{{ broadcastParamSt.title
                      }}</router-link>
                  </li>
                  <li class="breadcrumb-item active">
                    {{ title }} {{ copyLabel }}
                  </li>
                </ul>
              </div> 
            </div>
          </div>
          <!-- /Page Header -->
          <!-- /Search Filter -->
          <formPreview ref="formPreview" v-show="broadcastStep !== '2'" />
          <div class="row">
            <form2 v-show="broadcastStep === '2'" @update="previewPage" />
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import form0 from "./componentsV2/Forms/form0.vue";
import formPreview from "./componentsV2/Forms/formPreview.vue";
import form1 from "./componentsV2/Forms/form1.vue";
import form2 from "./componentsV2/Forms/form2.vue";
const defaultBroadcastParamSt = () => {
  return {
    //from state
    // form_speed: {
    //   delay_interval: { wait_min: 0, wait_max: 0 },
    //   rest_mode: { stop_after: 0, rest_for: 0 },
    // },
    error_import: 0,
    success_import: 0,
    is_import: 0,
    speed_mode: "safe",
    speed_wait_min: "0",
    speed_wait_max: "0",
    speed_stop_after: "0",
    speed_rest_for: "0",
    is_custom_url: false,
    rowDetail: {},
    is_duplicate: false,
    broadcast_id: "",
    title: "",
    provider: "whatsapp",
    license_id: "",
    to_group: [],
    to: [],
    is_group: 1, //for group set 1, for personal set 0
    is_group_type: "group", //group/tags
    message: {
      text: "",
      message_type: "text", //text,image,document
      file_url: "",
    },
    sending_options: 1,
    sending_schedule: "",
    is_recurring: 0,
    recurring_form: {
      recurrence: "",
      recurrence_time: "00:01",
      recurrence_every: "",
      recurrence_annually_month: "",
      recurrence_end: "never",
      recurrence_end_date: "",
    },
    is_send: 1,
    to_test: "",
    is_custom_url: false,
    interactive_message_status: false,
    interactive_message_type: "text_reply",
    footer_message_status: false,
    footer_message: "",
    buttons: [
      { id: "" },
      { id: "" },
      { id: "" },
      { id: "" },
      { id: "" },
      { id: "" },
      { id: "" },
      { id: "" },
      { id: "" },
      { id: "" },
    ],
    ab_testing_enabled: false,
    variants: [],
    pending_deleted_variant_codes: [],
    pending_deleted_variant_orders: [],
  };
};
export default {
  name: "wizardV2",
  components: {
    LayoutHeader,
    LayoutSidebar,
    form0,
    formPreview,
    form1,
    form2,
  },
  data() {
    return {
      title: "Broadcast",
      copyLabel: "Wizard",
      //   broadcastParamSt: defaultBroadcastParamSt(),
    };
  },
  computed: {
    isCompleteForm() {
      const { title, license_id, is_group, to_group, to, message } =
        this.broadcastParamSt;
      if (!title) return false;
      if (!license_id) return false;
      if (is_group) {
        if (!to_group.length) return false;
      } else {
        if (!to.length) return false;
      }
      if (!message.text) return false;
      return true;
    },
    broadcastParamSt: {
      get() {
        return this.$store.state.omniwa.broadcastParamSt;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastParamSt", val);
      },
    },
    broadcastStep: {
      get() {
        return this.$store.state.omniwa.broadcastStep;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastStep", val);
      },
    },
  },
  mounted() {
    this.broadcastParamSt = defaultBroadcastParamSt();
    this.$store.dispatch('omniwa/detailBroadcastSpeedInfo')
    let id = this.$route.query.id;
    if (typeof id != "undefined" && id != "") {
      this.title = "Ubah Broadcast";
      this.broadcastId = id;
      // console.log("id", id);
      this.detailBroadcast(id);
      this.broadcastStep = "";
    }
    let copy = this.$route.query.copy;
    this.isCopy = false;
    if (typeof copy != "undefined" && copy == "1") {
      this.copyLabel = " - COPY";
      this.isCopy = true;
      this.broadcastStep = "";
    }
    if(!id && !copy){
      this.broadcastStep = "0";
    }
  },
  methods: {
    async detailBroadcast(id) {
      this.isLoading = true;

      //set false dulu
      this.$store.dispatch("omniroom/setIsShowBroadcast", false);

      let dataParam = await {};
      dataParam = await {
        broadcast_id: id
      };
      let formData = await {};
      await this.$store
        .dispatch("omniwa/detailBroadcast", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          try {
            formData = JSON.parse(data.raw || "{}");
          } catch (e) {
            formData = {};
          }

          if (!formData.message) {
            formData.message = {
              text: data.message || "",
              message_type: data.message_type || "text",
              file_url: data.message_media || "",
            };
          }

          // Detail mengembalikan variants (otoritatif). Raw dipakai untuk
          // memulihkan message.file_url sumber asli bila tersedia.
          var rawVariants = (
            Array.isArray(formData.variants) ? formData.variants : []
          ).filter(function (variant) {
            return !variant.deleted;
          });
          var detailVariants = Array.isArray(data.variants)
            ? data.variants
            : [];
          var rawVariantByCode = {};
          rawVariants.forEach(function (variant) {
            rawVariantByCode[
              String(variant.variant_code || "").toUpperCase()
            ] = variant;
          });
          var sourceVariants = detailVariants.length
            ? detailVariants
            : rawVariants;
          var hasDetailValue = function (value) {
            return typeof value !== "undefined" && value !== null;
          };

          formData.variants = sourceVariants
            .map(function (variant) {
              var variantMessage = variant.message || {};
              var rawVariant =
                rawVariantByCode[
                  String(variant.variant_code || "").toUpperCase()
                ] || {};
              var rawMessage = rawVariant.message || {};
              var fileUrl =
                rawMessage.file_url || variantMessage.file_url || "";

              return {
                id: variant.id || rawVariant.id || "",
                variant_code: variant.variant_code || rawVariant.variant_code,
                variant_order:
                  variant.variant_order || rawVariant.variant_order,
                message: {
                  text: hasDetailValue(variantMessage.text)
                    ? variantMessage.text
                    : rawMessage.text || "",
                  message_type: hasDetailValue(variantMessage.message_type)
                    ? variantMessage.message_type
                    : rawMessage.message_type || "text",
                  file_url: fileUrl,
                },
                is_custom_url: hasDetailValue(variant.is_custom_url)
                  ? !!variant.is_custom_url
                  : !!rawVariant.is_custom_url,
                interactive_message_status: hasDetailValue(
                  variant.interactive_message_status
                )
                  ? !!variant.interactive_message_status
                  : !!rawVariant.interactive_message_status,
                interactive_message_type: hasDetailValue(
                  variant.interactive_message_type
                )
                  ? variant.interactive_message_type
                  : rawVariant.interactive_message_type || "",
                buttons: (
                  hasDetailValue(variant.buttons)
                    ? variant.buttons
                    : rawVariant.buttons || []
                ).map(function (button) {
                  return {
                    id: button.id || "",
                    button_text: button.button_text || "",
                  };
                }),
                footer_message_status: hasDetailValue(
                  variant.footer_message_status
                )
                  ? !!variant.footer_message_status
                  : !!rawVariant.footer_message_status,
                footer_message: hasDetailValue(variant.footer_message)
                  ? variant.footer_message
                  : rawVariant.footer_message || "",
                list_button_text: hasDetailValue(variant.list_button_text)
                  ? variant.list_button_text
                  : rawVariant.list_button_text || "Options",
                deleted: false,
              };
            })
            .sort(function (a, b) {
              return Number(a.variant_order) - Number(b.variant_order);
            });

          formData.ab_testing_enabled = formData.variants.length > 0;
          formData.pending_deleted_variant_codes = [];
          formData.pending_deleted_variant_orders = [];

          // console.log("formdataaa", formData);
          if (formData.is_send == 1 && this.isCopy == false) {
            this.$fire({
              title: "Error",
              text:
                "Hanya mengizinkan pesan dengan status Draft yang bisa diubah.",
              type: "error",
              timer: 3000
            });
            this.$router.push("/message_report/broadcast");
            return false;
          }
          this.isLoading = false;
        });
      formData.buttons = await [];
      await this.$store
        .dispatch("omniwa/detailButtonsBroadcast", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          if (data != null && data.length) {
            data.forEach((value, idx) => {
              // formData.buttons.push(value.id);
              formData.buttons.push({
                id: value.id,
                button_text: value.button_text
              });
            });
          }
        });
      // console.log(formData);
      formData.broadcast_id = id;
      await this.$store.dispatch("omniwa/actBroadcastParamSt", formData);
      this.getLabel()
    },
    async getLabel() {
      await this.$store
        .dispatch("license/getLicenseById", this.broadcastParamSt.license_id)
        .then(response => {
          var { data } = response;
          let licence = document.getElementById("license_id")
          // this.licenseInfo = data;
          licence.innerHTML = data.license_name;
          licence.innerHTML +=
            '<br /><span class="text-muted"><i class="fa fa-phone"></i> ' +
            data.license_phone_number +
            "</span>";
          this.$store
            .dispatch("omniwa/isOnline", data.license_phone_number)
            .then(responseDet => {
              var { data } = responseDet;
              this.responseDet = data;
              if (data.status === 1) {
                licence.innerHTML +=
                  ' <i title="Online" class="text-success fa fa-signal"></i>';
              } else {
                licence.innerHTML +=
                  ' <i title="Offline" class="text-danger fa fa-signal"></i>';
              }
            });
        });
    },
    previewPage(val) {
      console.log(val);
    },
  },
};
</script>
 


// WEBPACK FOOTER //
// src/views/broadcast/wizardV2.vue